export const restaurantStyles = ["QSR", "FSR"] as const;

export const restaurantTypes = {
  QSR: ["Fast food", "Casual", "Grab & go", "Food truck", "Drive thru"],
  FSR: ["Fine dining", "Casual dining", "Bar", "Cafe"],
} as const;

export const allRestaurantTypes = [
  "Fast food",
  "Casual",
  "Grab & go",
  "Food truck",
  "Drive thru",
  "Fine dining",
  "Casual dining",
  "Bar",
  "Cafe",
] as const;

export const restaurantOperationalStatuses = [
  "OPEN",
  "TEMPORARILY_CLOSED",
  "PERMANENTLY_CLOSED",
] as const;

export const restaurantOperationalStatusComboboxOptions: {
  label: string;
  value: string;
}[] = [
  {
    value: restaurantOperationalStatuses[0],
    label: "Open",
  },
  {
    value: restaurantOperationalStatuses[1],
    label: "Temporarily closed",
  },
  {
    value: restaurantOperationalStatuses[2],
    label: "Permanently closed",
  },
];
